import { Inject, Component } from "@angular/core";
import { ConfigurationSessionManager, ConfiguratorStore, ConfPageSessionService } from "../providers";
import * as Immutable from 'immutable';
import { SummaryBaseComponent } from "./summaryBaseComponent";
import { ConfUIItem, CodeDisplayStyles, CodePanel, GroupConfUIItem, DocumentsPanel, ConfFormValue, Form } from "../../shared/models";
import { ProductDataStore } from "../../shared/providers/productData";
import { CodeValueModelBuilder } from "../../shared/components/code/providers/codeValueModelBuilder";
import { CodePanelValuesModel } from "../../shared/components/code/codePanelValueModel";
import { GlobalDataStore } from "../../shared/providers/globalData/globalDataStore";
import { VisualObjectUIDataService } from "../shared/visualObjectUIDataService";
import { FormValueModelBuilder } from "../../shared/components/form";
import { VisualObjectHelper } from "../parameters/shared";


export enum ActionBoxNames {
  Operations = 'operations',
  States = 'states',
  Revisions = 'revisions',
  Reports = 'reports',
  Forms = 'forms',
  Code = 'code',
  Documents = 'documents',
  Graphics = 'graphics',
  Attachments = 'attachments'
}

@Component({
  selector: 'summary-action-boxes',
  templateUrl: './summaryActionsBoxesComponent.html',
  providers: [VisualObjectUIDataService, VisualObjectHelper]
})
export class SummaryActionsBoxesComponent extends SummaryBaseComponent {
  actionBoxNames = ActionBoxNames;

/*  codeUIItems: Immutable.List<ConfUIItem> = Immutable.List<ConfUIItem>();*/
  documentsUIItems: Immutable.List<ConfUIItem> = Immutable.List<ConfUIItem>();

  forms: Immutable.List<Form> = Immutable.List<Form>();

  orderList: Immutable.List<string> = Immutable.List<string>();

  // List of each panel values.
  panelValuesModels: Immutable.List<CodePanelValuesModel> = Immutable.List<CodePanelValuesModel>();

  disableAttachments: boolean = false;
  disableOptions: boolean = false;
  disableRevisions: boolean = false;
  disableStates: boolean = false;

  constructor(@Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(CodeValueModelBuilder) public codeValueModelBuilder: CodeValueModelBuilder,
    @Inject(FormValueModelBuilder) public formValueModelBuilder: FormValueModelBuilder,
    @Inject(GlobalDataStore) public globalDataStore: GlobalDataStore) {
    super(confPageSessionService);
  }

  onDataReady(): void {

    this.orderList = this.globalDataStore.globalSettings.summaryActionBoxesDisplayOrder;
    this.disableAttachments = this.globalDataStore.globalSettings.summaryDisableUploadItem;
    this.disableOptions = this.globalDataStore.globalSettings.summaryDisableOptionItems;
    this.disableRevisions = this.globalDataStore.globalSettings.disableRevisionManagement;
    this.disableStates = this.globalDataStore.globalSettings.summaryDisableStateItem;

    // TODO: This part requires more improvement.
    const uiItems: Array<ConfUIItem> = this.confPageSessionService.activeConfiguration.uiItems
      .filter(uiItem => uiItem.itemName == CodePanel.name).toArray();

    if (this.globalDataStore.globalSettings.displayDocumentsInOperationsColumn)
      this.documentsUIItems = this.confPageSessionService.activeConfiguration.uiItems
        .filter(uiItem => uiItem.itemName == DocumentsPanel.name).toList();

    const formUIItems: Array<ConfUIItem> = this.confPageSessionService.activeConfiguration.uiItems
      .filter(uiItem => uiItem.itemName == Form.name).toArray();

    const codeFilteredStyles = [CodeDisplayStyles.DownloadLink, CodeDisplayStyles.Popup];

    this.panelValuesModels = this.panelValuesModels.clear();
    uiItems.forEach(x => {

      // Note! Grouping is not supported yet for action boxes. We need more work on this part.
      let ValuesModels = this.codeValueModelBuilder.build(x, false, codeFilteredStyles, this.configurationId).toArray();
      this.panelValuesModels = this.panelValuesModels.push(...ValuesModels);

    });

    this.forms = this.forms.clear();
    formUIItems.forEach(x => {

      // Note! Grouping is not supported yet for action boxes. We need more work on this part.
      let form = this.formValueModelBuilder.build(x, false);

      if (form)
        this.forms = this.forms.push(form);

    });

  }

}